export default {
    /**
     * функция геттер преобразует строку в объект даты
     * @param datetime
     * @returns {Date}
     */
    getParseDateFromString(datetime) {
        if (datetime) {
            if (datetime.includes("|")) {
                const dateArray = datetime.split("|");
                for (let i = 0; i < dateArray.length; i++) {
                    dateArray[i] = new Date(dateArray[i]);
                }
                return dateArray;
            } else {
                return new Date(datetime);
            }
        } else {
            return null;
        }
    },
    /**
     * функция геттер автоматически преобразует первую букву строки в заглавную
     * @param string - преобразуемая строка
     * @returns {string|{length}|*}
     */
    getAutoUpperCaseFIO(string) {
        if (string.length && string[0] !== string[0].toUpperCase()) {
            return string[0].toUpperCase() + string.slice(1);
        } else {
            return string;
        }
    },
    /**
     * функция геттер преобразует строку даты из python формата в формат дд.мм.гг
     * @param datetime
     * @returns {string|null}
     */
    getParseDateForTables(datetime) {
        if (datetime) {
            const new_date = new Date(datetime);
            return `${this.checkTime(new_date.getDate())}.${this.checkTime(
                new_date.getMonth() + 1
            )}.${new_date.getFullYear()}`;
        } else {
            return null;
        }
    },
    /**
     * функция геттер сортирует массив по алфавиту
     * @param array - массив для сортировки
     * @returns {*}
     */
    sortByAlphabet(array) {
        return array.sort((a, b) => a.name.localeCompare(b.name));
    },
    /**
     * функция геттер создает новый объект даты и преобразует формат и возвращает это значение
     * @param datetime
     * @returns {string}
     */
    getParseDate(datetime) {
        if (datetime) {
            if (Array.isArray(datetime)) {
                const start_date = new Date(datetime[0]);
                let end_date;
                if (datetime[1]) {
                    end_date = new Date(datetime[1]);
                } else {
                    end_date = start_date;
                }
                return `${start_date.getFullYear()}-${
                    start_date.getMonth() + 1
                }-${start_date.getDate()}|${end_date.getFullYear()}-${
                    end_date.getMonth() + 1
                }-${end_date.getDate()}`;
            } else {
                const new_date = new Date(datetime);
                return `${new_date.getFullYear()}-${
                    new_date.getMonth() + 1
                }-${new_date.getDate()}`;
            }
        } else {
            return null;
        }
    },
    /**
     * функция возвращает двухзначное число, в случае если на входе число до 10
     * @param i
     * @returns {string}
     */
    checkTime(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    },
    /**
     * возвращает закодированную строку (кодирует URI в доступные символы из UTF8)
     * @param name
     * @returns {string}
     */
    getEncodeString(name) {
        return encodeURIComponent(name);
    },
    /**
     * возвращает декодированную строку
     * @param name
     * @returns {string}
     */
    getDecodeString(name) {
        return decodeURIComponent(name);
    },
    /**
     * геттер, который возвращает значение проверки объекта на пустоту
     * @param obj - проверяемый объект
     * @returns {boolean}
     */
    isEmpty(obj) {
        if (typeof obj === `object`) {
            for (let key in obj) {
                return false;
            }
            return true;
        } else {
            return true;
        }
    },
    /**
     * геттер, который возвращает значение проверки значения на равенство id страны "Россия"
     * @param country - страна
     * @returns {boolean}
     */
    isCountryRussiaID(country) {
        return country === 1;
    },
    /**
     * геттер, который возвращает ФИО (соединяет имя, фамилию и отчество в одну строку)
     * @param person - объект с данными по человеку
     * @returns {string}
     */
    getJoinFIO(person) {
        return (
            `${person.surname ? person.surname : ""}` +
            ` ${person.name ? person.name : ""}` +
            ` ${person.patronymic ? person.patronymic : ""}`
        );
    },
    /**
     * геттер, который возвращает локацию (соединяет страну с субъектом в одну строку)
     * @param country - страна
     * @param subject - субъект
     * @returns {string}
     */
    getJoinLocation(country, subject) {
        if (country && subject) {
            return `${country}, ${subject}`;
        } else if (country) {
            return `${country}`;
        } else {
            return `${subject}`;
        }
    },
    /**
     * функция гетер для каждого элемента массива населенных пунктов устанавливает
     * ключ full_name, в формате "Наимен.субъекта РФ Тип нас.пункта Наимен. нас.пункта"
     * @param settlements - массив населенных пунктов
     */
    setSettlementUpdateName(settlements) {
        settlements.forEach((settlement) => {
            if (settlement.locality_type.id) {
                const { locality_type } = settlement;
                settlement.name = `${locality_type.name.toLowerCase()} ${
                    settlement.name
                }`;
            }

            if (settlement.subject.id && !settlement.is_federal) {
                const { subject } = settlement;
                settlement.full_name = `${subject.name} ${settlement.name}`;
            }
        });
    },
    getFiltersName(objectFields) {
        const te = {};
        for (let key in objectFields) {
            if (
                typeof objectFields[key] === "object" &&
                objectFields[key] !== null
            ) {
                te[key] = {};
                if (objectFields[key]["name"]) {
                    te[key]["name"] = "";
                }
                if (objectFields[key]["surname"]) {
                    te[key]["surname"] = "";
                }
            } else {
                te[key] = "";
            }
        }
        return te;
    },
    deleteDuplicate(obj) {
        return obj.reduce((o, i) => {
            if (!o.find((v) => v.name === i.name)) {
                o.push(i);
            }
            return o;
        }, []);
    },
    /**
     * Возвращает новую строку, где первый символ заглавным
     * @param str - строка
     * @returns {string|*}
     */
    ucFirst(str) {
        if (!str) return str;
        return str[0].toUpperCase() + str.slice(1).toLowerCase();
    },
};
